import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { getDummyText, getPlaceholderUrl } from "../../../../utils";

interface TemplateArgs {
    className?: string;
    tags?: string;
    supportedTags?: string;
    supportedTagsLabel?: string;
    highlightedTags?: string;
    featuresLabel?: string;
}

export const Template = ({
    className,
    tags,
    supportedTags,
    supportedTagsLabel,
    highlightedTags,
    featuresLabel,
}: TemplateArgs) => html`
    <ux-iws-nb-teaser-product
        class=${ifDefined(className)}
        tags=${ifDefined(tags)}
        supported-tags=${ifDefined(supportedTags)}
        supported-tags-label=${ifDefined(supportedTagsLabel)}
        highlighted-tags=${ifDefined(highlightedTags)}
        features-label=${ifDefined(featuresLabel)}
    >
        <div slot="image">
            <picture>
                <img
                    class="lazyload"
                    alt="Product Image with 3:2 aspect ratio"
                    src="${getPlaceholderUrl(1200, 800)}"
                    data-src="mock-assets/images/trulasercell5030.jpg"
                />
            </picture>
        </div>
        <h3 slot="title" class="headline-big">TruLaser Cell 5030</h3>
        <p slot="subtitle">${getDummyText(200)}</p>
        <ul slot="features">
            <li>${getDummyText(50)}</li>
            <li>${getDummyText(80)}</li>
            <li>${getDummyText(60)}</li>
            <li>${getDummyText(40)}</li>
        </ul>
        <p slot="description">${getDummyText(262)}</p>
        <div slot="cta">
            <ux-button
                variant="primary"
                href="#"
                icon="arrow-small-right"
                icon-placement="end"
                aria-label="Zum Produkt"
            >
                Zum Produkt
            </ux-button>
        </div>
    </ux-iws-nb-teaser-product>
`;

export const templateArgs = {
    tags: "Schweissen,Schneiden,Markieren,Additive Fertigung,3D-Druck",
    supportedTags: "Schweissen,Schneiden",
    supportedTagsLabel: "Unterstützte Anwendungen",
    highlightedTags: "Schneiden",
    featuresLabel: "Hauptmerkmale",
};
